module.exports = __webpack_public_path__ + "footer-logo-6d3787c4.png";